import { render, staticRenderFns } from "./cmsArticleEdit.vue?vue&type=template&id=083b9cbc&"
import script from "./cmsArticleEdit.vue?vue&type=script&lang=js&"
export * from "./cmsArticleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports